import request from "./request";

const ReviewMCQExamService = {
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/reviewmcqexam/${id}`, context.token, signal);
    },
    GetByExam: async (id, context, signal) => {
        return await request.sendRequest(`/reviewmcqexam/exam/${id}`, context.token, signal);
    },
};

export default ReviewMCQExamService;
